var _circle, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGroup11487(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 41,
    viewBox: "0 0 41 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.4,
    cx: 20.5,
    cy: 20.5,
    r: 20.5,
    fill: "#0067FF",
    fillOpacity: 0.3
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4190_21434)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.5 20.4709V16.5C24.5 11.6314 20.5539 9.20776 20.3859 9.10688C20.2693 9.03694 20.1359 9 20 9C19.8641 9 19.7307 9.03694 19.6141 9.10688C19.4461 9.20776 15.5 11.6314 15.5 16.5V20.4709C14.2314 21.0315 12.5 22.5461 12.5 25.5C12.5 25.6989 12.579 25.8897 12.7197 26.0303C12.8603 26.171 13.0511 26.25 13.25 26.25H26.75C26.9489 26.25 27.1397 26.171 27.2803 26.0303C27.421 25.8897 27.5 25.6989 27.5 25.5C27.5 22.5465 25.7686 21.0315 24.5 20.4709Z",
    fill: "#006EA0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.3859 9.10688C20.2693 9.03694 20.1359 9 20 9C19.8641 9 19.7307 9.03694 19.6141 9.10688C19.4461 9.20776 15.5 11.6314 15.5 16.5V25.5C15.5 25.6989 15.579 25.8897 15.7197 26.0303C15.8603 26.171 16.0511 26.25 16.25 26.25H23.75C23.9489 26.25 24.1397 26.171 24.2803 26.0303C24.421 25.8897 24.5 25.6989 24.5 25.5V16.5C24.5 11.6314 20.5539 9.20776 20.3859 9.10688Z",
    fill: "#96DCFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20 27C18.7591 27 17.75 28.0091 17.75 29.25C17.75 30.2089 18.8919 31.9654 19.3828 32.6764C19.4519 32.7761 19.5442 32.8576 19.6516 32.9138C19.7591 32.9701 19.8787 32.9995 20 32.9995C20.1213 32.9995 20.2409 32.9701 20.3484 32.9138C20.4558 32.8576 20.5481 32.7761 20.6172 32.6764C21.1081 31.9654 22.25 30.2089 22.25 29.25C22.25 28.0091 21.2409 27 20 27ZM20 15.75C18.7591 15.75 17.75 16.7591 17.75 18V21C17.75 22.2409 18.7591 23.25 20 23.25C21.2409 23.25 22.25 22.2409 22.25 21V18C22.25 16.7591 21.2409 15.75 20 15.75Z",
    fill: "#00AAFF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4190_21434"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(8 9)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup11487);
export default __webpack_public_path__ + "static/media/Group 11487.9ae04091d9d410824a04b3ca9f7586a5.svg";
export { ForwardRef as ReactComponent };